import { useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
// import RegularButton from "../Components/CustomButtons/Button";
import MedineerLogin from "../Components/MedineerComponents/MedineerLogin";
import "./KnowYourCollege.css"; // import CSS

// import styles from "../styles/Home.module.css";
// import React, { useState } from "react";
// import { useMediaQuery, useTheme } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import MedineerLogin from "./MedineerComponents/MedineerLogin";

const HerosCollegePredictor = ({ subscription, isLoggedIn, hideTestDetails }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();

    const [price] = useState(subscription?.price ?? 0);
    const [showCheckout, setShowCheckout] = useState(false);

    const series = {
        subscriptionTypeId: subscription?.subscriptionTypeId,
        courseId: subscription?.subscriptionTypeId ?? 0,
        price: price ?? 0,
    };

    const onNextHandle = () => {
        const ResourceTypeId = 4;
        if (isLoggedIn) {
            setShowCheckout(true);
        } else {
            navigate("/medineer/SignUp", { state: { series, ResourceTypeId } });
        }
    };

    const handleCloseModal = () => {
        hideTestDetails?.();
        setShowCheckout(false);
    };

    return (
        <div className="knowYourCollegeContainer">
            <div className="imageContainer">
                <img
                    src={"collegeImg.png"}
                    alt="Students discussing college predictor"
                />
            </div>

            <div className="textContainer">
                <div className="subHeader">

                    <h2>
                        Know Your College <span>Just @ ₹ {price}/-</span>
                    </h2>
                </div>

                <hr
                    style={{ height: "4px", background: "#f8cb1e", margin: "10px 0" }}
                />

                <ul className={isMobile ? "detailsPointsMobile" : "detailsPoints"}>
                    <li>
                        Check admission chances based on your <b>MHT-CET rank</b>,{" "}
                        <b>category</b>, <b>preferred city</b>, and <b>branch choices</b>.
                    </li>
                    <li>
                        Get precise insights into <b>college rankings</b> and <b>cut-offs</b>{" "}
                        for different streams.
                    </li>
                    <li>
                        Use <b>AI-powered predictions</b> to find the most suitable colleges
                        based on past trends and data.
                    </li>
                    <li>
                        Plan strategically with <b>personalized recommendations</b> to
                        improve your chances of admission.
                    </li>
                </ul>
                <div className="buttonContainer">
                    <button className="signUpButton" onClick={onNextHandle}>
                        Sign up
                    </button>
                </div>
                {showCheckout && (
                    <MedineerLogin
                        course={series}
                        ResourceTypeId={4}
                        closeModal={handleCloseModal}
                    />
                )}
            </div>
        </div>
    );
};

export default HerosCollegePredictor;
